import type { SecretaryAvatarPreset } from '../../../shared/secretaryPreferences';

/** 内置头像配色仅映射到静态样式，禁止将用户输入拼接成 CSS 或资源地址。 */
export const secretaryAvatarColors: Record<SecretaryAvatarPreset, string> = {
  blue: 'bg-blue-100 ring-blue-400 dark:bg-blue-950',
  violet: 'bg-violet-100 ring-violet-400 dark:bg-violet-950',
  teal: 'bg-teal-100 ring-teal-400 dark:bg-teal-950',
  amber: 'bg-amber-100 ring-amber-400 dark:bg-amber-950',
  rose: 'bg-rose-100 ring-rose-400 dark:bg-rose-950',
};

/** 复用 BoMate 内置头像；配色用于外圈，设置预览与会话身份共用同一组件。 */
export default function SecretaryAvatar({ preset = 'blue', className = 'h-12 w-12' }: {
  /** 用户选择的内置配色；不读取或暴露桌面端头像路径。 */
  preset?: SecretaryAvatarPreset;
  className?: string;
}) {
  return <span aria-hidden="true" className={`inline-flex shrink-0 items-center justify-center rounded-full p-1 ring-2 ring-offset-2 ring-offset-claude-bg dark:ring-offset-claude-darkBg ${secretaryAvatarColors[preset] ?? secretaryAvatarColors.blue} ${className}`}>
    <img src={`${import.meta.env.BASE_URL}secretary-avatar.png`} alt="" draggable={false} className="h-full w-full rounded-full object-cover" />
  </span>;
}
